import gql from "graphql-tag";

export const GET_MOCK_DATA = gql`
  query getMockData($notion: NotionTypeEnum!, $type: MockTypeEnum!) {
    mock(notion: $notion, type: $type)
  }
`;
